import { connect } from 'react-redux';
import type { FutureNextStepsProps } from '@/pages/CompanyReport/components/Future';
import { FutureNextSteps } from '@/pages/CompanyReport/components/Future';
import {
  getSummary,
  getManagement,
} from '@/pages/CompanyReport/redux/selectors';
import { getPeople } from '@ducks/people/selectors';
import { get } from 'lodash';

type ContainerProps = { companyId?: string; isDataMeaningless: boolean };

const mapStateToProps = (
  state,
  { companyId, isDataMeaningless }: ContainerProps
): FutureNextStepsProps => {
  const management = getManagement(state, { companyId });
  const summary = getSummary(state, { companyId });
  const people = getPeople(state);
  const leader = people[management.leaderId];
  return {
    countryISO: summary.countryISO,
    isDataMeaningless,
    scorePast: summary.score.past,
    scoreValue: summary.score.value,
    companyName: summary.shortName,
    scoreHealth: summary.score.health,
    tickerSymbol: summary.tickerSymbol,
    scoreDividend: summary.score.income,
    CEOCompensation: get(leader, 'compensation', undefined),
    exchangeSymbol: summary.exchangeSymbol,
    industryPrimaryName: summary.industryData.primaryName,
  };
};

export default connect(mapStateToProps)(FutureNextSteps);
